export default __webpack_public_path__ + "static/media/sad_mans_4.cbe13634.png";